import { render, staticRenderFns } from "./ReviewsCategoriesHeatmapDropdown.vue?vue&type=template&id=23a565e0&scoped=true&"
import script from "./ReviewsCategoriesHeatmapDropdown.vue?vue&type=script&lang=js&"
export * from "./ReviewsCategoriesHeatmapDropdown.vue?vue&type=script&lang=js&"
import style0 from "./ReviewsCategoriesHeatmapDropdown.vue?vue&type=style&index=0&id=23a565e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a565e0",
  null
  
)

export default component.exports